<script lang="ts">
    export let title = '';
</script>


<button class="pulse-button" title={title} on:click>
    <slot />
</button>


<style lang="scss">
  .pulse-button {
    font-size: 90%;
    padding: 0 1px 0 0;
    width: 34px;
    height: 34px;
    margin: 5px 6px;
    border: none;
    box-shadow: 0 0 0 0 rgba(232, 76, 61, 0.7);
    border-radius: 50%;
    background-color: #ca003a;
    color: white;
    cursor: pointer;
    -webkit-animation: pulse 1.25s cubic-bezier(.66,0,0,1) infinite;
    -moz-animation: pulse 1.25s infinite cubic-bezier(.66,0,0,1);
    -ms-animation: pulse 1.25s infinite cubic-bezier(.66,0,0,1);
    animation: pulse 1.25s cubic-bezier(.66,0,0,1) infinite;
  }

  .pulse-button:hover {
    -webkit-animation: none;
    -moz-animation: none;
    -ms-animation: none;
    animation: none;
    border: 1px solid darkgray;
  }

  @-webkit-keyframes pulse {to {box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);}}
  @-moz-keyframes pulse {to {box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);}}
  @-ms-keyframes pulse {to {box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);}}
  @keyframes pulse {to {box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);}}
</style>